export const SET_MAINTENANCE_MODE_IS_ACTIVE = 'ui/SET_MAINTENANCE_MODE_IS_ACTIVE';
export const REHYDRATE = 'persist/REHYDRATE';
export const SET_LOGIN_STATUS = 'ui/SET_LOGIN_STATUS';

export const initialState = {
  isMaintenanceModeActive: false,
  isLoggedIn: false,
};

export const setMaintenanceModeIsActive = isActive => ({
  type: SET_MAINTENANCE_MODE_IS_ACTIVE,
  payload: { isActive },
});

export const setLoginStatus = status => ({
  type: SET_LOGIN_STATUS,
  payload: { status },
});

export const uiReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REHYDRATE:
      return { ...action.payload.ui, ...state };
    case SET_LOGIN_STATUS:
      return { ...state, isLoggedIn: action.payload.status };
    case SET_MAINTENANCE_MODE_IS_ACTIVE:
      return { ...state, isMaintenanceModeActive: !!action.payload.isActive };
    default:
      return state;
  }
};
